//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'artist-profile-tools-card',
  props: {
    artist: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tools() {
      return _.get(this.artist, 'tools', []);
    },
  },
};
